import { render, staticRenderFns } from "./memoryGame.vue?vue&type=template&id=34521728&scoped=true&"
import script from "./memoryGame.vue?vue&type=script&lang=js&"
export * from "./memoryGame.vue?vue&type=script&lang=js&"
import style0 from "./memoryGame.vue?vue&type=style&index=0&id=34521728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34521728",
  null
  
)

export default component.exports